import { render, staticRenderFns } from "./DrawImage.vue?vue&type=template&id=2407a2ac&"
import script from "./DrawImage.vue?vue&type=script&lang=js&"
export * from "./DrawImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports